import React from 'react';
import './Image.css';

const Image = ({src, alt, format, padding, retina}) => {
  let style = padding ? {padding: '4px'} : {};
  return (
    <div className="Image-padding" style={style}>
      <div className={`Image-container-${format}`} >
        <img className={`Image-${format}`} src={src} srcSet={`${src} 1x, ${retina} 2x`} alt={alt} />
      </div>
    </div>
  )
}

export default Image;


// WEBPACK FOOTER //
// ./src/components/galleryItems/Image.js